import Vue from 'vue';
import { Prize } from '@/model/prize';
import { Score } from '@/model/score';
import { User } from '@/model/user';
import * as Constants from '@/utils/constants';
import { HttpOptions } from 'vue-resource/types/vue_resource';
import * as DateUtils from '@/utils/dateUtils';
import * as DTOUtils from '@/utils/dtoUtils';
import { UserPrize } from '@/model/userPrize';
import { UserPrizeDTO } from '@/dto/userPrizeDTO';
import { ScoreDTO } from '@/dto/scoreDTO';

export class UserService extends Vue {

    constructor() {
      super();
    }

    public getAllUsers(token: string) {
      const options: HttpOptions = {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': 'access-control-allow-origin, access-control-allow-headers, authorization',
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
        },
      };

      return new Promise((resolve) => {
        this.$http.get(Constants.API_DEV_URL + '/' + 'user' + '/' + 'userList', options)
        .then((response) => {
            resolve(response.json());
          });
      });
    }

    
    public downloadlUserList(token: string) {
        const options: HttpOptions = {
          headers: {
              'Authorization': 'Bearer ' + token,
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Headers': 'access-control-allow-origin, access-control-allow-headers, authorization',
              'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
              'Accept': 'text/csv'
          },
        };
  
        this.$http.get(Constants.API_DEV_URL + '/' + 'user' + '/' + 'userListCsv', options)
        .then((response) => {
            console.log(response.data);
            const blob = new Blob([response.data],{type:'text/csv'});
            if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
                const url = window.URL.createObjectURL(blob);
                window.open(url);
            } else {
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = "users.csv";
                link.click();
            }
        });
        
      }

    

      public getUser(userCode: string, token: string) {
        const options: HttpOptions = {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Access-Control-Allow-Origin': '*',
                // tslint:disable-next-line:max-line-length
                'Access-Control-Allow-Headers': 'access-control-allow-origin, access-control-allow-headers, authorization',
                'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
            },
        };

        return new Promise((resolve, reject) => {
            // tslint:disable-next-line:max-line-length
            this.$http.get(Constants.API_DEV_URL + '/' + 'user' + '/' + 'getUser' + '?' + 'code=' + userCode, options)
            .then((response) => {
                resolve(response.json());
            });
        });
    }

    public getAllUserPrizes(userCode: string, token: string): Promise<Array<UserPrize>> {
        const options: HttpOptions = {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Access-Control-Allow-Origin': '*',
                // tslint:disable-next-line:max-line-length
                'Access-Control-Allow-Headers': 'access-control-allow-origin, access-control-allow-headers, authorization',
                'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
            },
        };

        return new Promise((resolve, reject) => {
            // tslint:disable-next-line:max-line-length
            this.$http.get(Constants.API_DEV_URL + '/' + 'userPrize' + '/' + 'getAllPrizes' + '?' + 'code=' + userCode, options)
            .then((response) => {
                const userPrizes = new Array<UserPrize>();
                const userPrizesData: Array<UserPrizeDTO> = response.data;
                userPrizesData.forEach((upDTO: UserPrizeDTO) => {
                    // tslint:disable-next-line:max-line-length
                    const up: UserPrize = DTOUtils.getUserPrizeModel(upDTO);//new UserPrize(el.id, el.prize, el.bookingDate);
                    if (upDTO.collectionDate) {
                        up.collectionDate = DateUtils.arrayToDate(upDTO.collectionDate);
                        up.redeemed = true;
                    }
                    userPrizes.push(up);
                });
                resolve(userPrizes);
            });
        });
    }

    public getUserScore(userCode: string, token: string): Promise<Score> {
        const options: HttpOptions = {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Access-Control-Allow-Origin': '*',
                // tslint:disable-next-line:max-line-length
                'Access-Control-Allow-Headers': 'access-control-allow-origin, access-control-allow-headers, authorization',
                'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE, OPTIONS',
            },
        };

        return new Promise<Score>((resolve, reject) => {
            // tslint:disable-next-line:max-line-length
            this.$http.get(Constants.API_DEV_URL + '/' + 'score' + '/' + 'getScore' + '?' + 'code=' + userCode, options)
            .then((response) => {
                const scoreDTO: ScoreDTO = response.data;
                const score: Score = DTOUtils.getScoreModel(scoreDTO);
                resolve(score);
            });
        });
    }
}
